import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import "./scrolltab.scss";
import {TabFormat} from "../../../modals/types/tab"

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{p: 3}}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

export default function ScrollTab({tabs, tabPanel}: TabFormat) {
    const [value, setValue] = React.useState(tabs.length - 1);

    //@ts-ignore
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <>
            <Box sx={{direction: 'ltr'}}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    aria-label="scrollable force tabs example"
                >
                    {
                        tabs.map((tab, index) => {
                            return (
                                <Tab key={index} label={tab}/>
                            );
                        })
                    }
                </Tabs>
            </Box>
            <div className="bg-white w-100">
                {
                    tabPanel.map((option, index) => {
                        return (
                            <TabPanel key={index} value={value} index={index}>
                                {option}
                            </TabPanel>
                        );
                    })
                }
            </div>
        </>
    );
}
